// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.engagementTableWrapper__T2I0r {
  width: 100%;
  max-width: 100%;
  max-height: calc(100vh - 322px);
  overflow: auto;
  box-shadow: var(--basic-box-shadow);
  margin-top: 25px;
}
.engagementTableWrapper__T2I0r::-webkit-scrollbar {
  width: 6px;
  height: 6px;
  border-radius: 3px;
}
.engagementTableWrapper__T2I0r::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.05);
  border-radius: 3px;
}
.engagementTableWrapper__T2I0r::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.2);
  border-radius: 3px;
}
.engagementTableWrapper__T2I0r::-webkit-scrollbar-thumb:hover {
  background: #888;
  border-radius: 3px;
}
@media (max-width: 900px) {
  .engagementTableWrapper__T2I0r {
    margin-top: 15px;
    max-height: calc(100vh - 280px);
  }
}

.engagementTable__awaQV {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  position: relative;
}
.engagementTable__awaQV th {
  font-size: 10px;
  font-weight: 400;
  line-height: 12px;
  text-transform: uppercase;
  color: var(--tables-title-text);
  padding: 16px 25px;
  text-align: left;
  border-bottom: 1px solid var(--tables-title-stroke);
  background: var(--tables-title-surface);
  text-wrap: nowrap;
  position: sticky;
  top: 0;
  z-index: 1;
}
@media (max-width: 1550px) {
  .engagementTable__awaQV th {
    padding: 16px 12px;
  }
}
@media (max-width: 1380px) {
  .engagementTable__awaQV th {
    padding: 10px 6px;
  }
}
@media (max-width: 900px) {
  .engagementTable__awaQV th {
    padding: 8px 3px;
    font-size: 9px;
  }
}
.engagementTable__awaQV td {
  padding: 16px 25px;
  color: var(--tables-primary-row-text-main);
  border-bottom: 1px solid var(--tables-primary-row-stroke);
  background: var(--tables-primary-row-surface-default);
  letter-spacing: 0.01em;
  font-size: 12px;
  line-height: 16px;
}
@media (max-width: 1550px) {
  .engagementTable__awaQV td {
    padding: 16px 12px;
  }
}
@media (max-width: 1380px) {
  .engagementTable__awaQV td {
    padding: 10px 6px;
    font-size: 10px;
  }
}
@media (max-width: 900px) {
  .engagementTable__awaQV td {
    padding: 8px 3px;
  }
}

.engagementBodyRow__Hu2OD:hover {
  border-bottom: 1px solid var(--tables-primary-row-stroke);
  background: var(--tables-primary-row-surface-hover);
  cursor: pointer;
}

.engagementTableSortIcon__hUZVi {
  margin-left: 5px;
  cursor: pointer;
  outline: none;
  min-width: 6px;
}
.engagementTableSortIcon__hUZVi path {
  fill: var(--tables-title-icon);
}

.activeSort__E2dCn path {
  fill: var(--tables-primary-row-icon);
}

.ellipsisTextTwoLines__j6LI1 {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: pre-wrap;
  word-wrap: break-word;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  line-clamp: 2;
}

.ellipsisTextThreeLines__vq9S9 {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: pre-wrap;
  word-wrap: break-word;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  line-clamp: 3;
}

.additionalField__oW0Vo {
  color: var(--tables-primary-row-text-additional);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: pre-wrap;
  word-wrap: break-word;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  line-clamp: 1;
}

.alignRightColumn__fYFYM {
  text-align: right !important;
}

.lifetimeRange__l6bPc {
  white-space: nowrap;
}
@media (max-width: 1070px) {
  .lifetimeRange__l6bPc {
    white-space: wrap;
  }
}

.pointName__wOIGW {
  display: none;
  color: var(--tables-primary-row-text-additional);
}
@media (max-width: 1380px) {
  .pointName__wOIGW {
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: pre-wrap;
    word-wrap: break-word;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    line-clamp: 2;
  }
}

@media (max-width: 1380px) {
  .smallWidthHide__de2hC {
    display: none;
  }
}

.smallWidthShow__d2vuI {
  display: none;
}
@media (max-width: 1380px) {
  .smallWidthShow__d2vuI {
    display: block;
  }
}

.sortColumnWrapper__uVBj4 {
  display: flex;
  align-items: center;
}

.skeletonText__gBBeC {
  height: 24px;
}

.tooltipSizeMedium__dq61M {
  max-width: 450px;
}

.statusTypeItemContainer__nXH7M {
  display: flex;
}

.skeletonRow__zG7Iu td {
  padding-top: 15px;
  padding-bottom: 14px;
}
.skeletonRow__zG7Iu td:not(:last-child) {
  padding-right: 0;
}
@media (max-width: 1380px) {
  .skeletonRow__zG7Iu td:nth-child(n+8) {
    display: none;
  }
}

@media (max-width: 900px) {
  .equipmentInfo__OCr8z {
    max-width: 85px;
  }
}`, "",{"version":3,"sources":["webpack://./../src/pages/SiteEngagement/components/TableEngagementActionItems/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,WAAA;EACA,eAAA;EACA,+BAAA;EACA,cAAA;EACA,mCAAA;EACA,gBAAA;AAzEF;AAmBE;EACE,UAAA;EACA,WAAA;EACA,kBAAA;AAjBJ;AAoBE;EACE,+BAAA;EACA,kBAAA;AAlBJ;AAqBE;EACE,8BAAA;EACA,kBAAA;AAnBJ;AAsBE;EACE,gBAAA;EACA,kBAAA;AApBJ;AA4DE;EAVF;IAWI,gBAAA;IACA,+BAAA;EAzDF;AACF;;AA4DA;EACE,WAAA;EACA,yBAAA;EACA,iBAAA;EACA,kBAAA;AAzDF;AA2DE;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;EACA,+BAAA;EACA,kBAAA;EACA,gBAAA;EACA,mDAAA;EACA,uCAAA;EACA,iBAAA;EACA,gBAAA;EACA,MAAA;EACA,UAAA;AAzDJ;AA2DI;EAfF;IAgBI,kBAAA;EAxDJ;AACF;AA0DI;EAnBF;IAoBI,iBAAA;EAvDJ;AACF;AAyDI;EAvBF;IAwBI,gBAAA;IACA,cAAA;EAtDJ;AACF;AAyDE;EACE,kBAAA;EACA,0CAAA;EACA,yDAAA;EACA,qDAAA;EACA,sBAAA;EACA,eAAA;EACA,iBAAA;AAvDJ;AAyDI;EATF;IAUI,kBAAA;EAtDJ;AACF;AAwDI;EAbF;IAcI,iBAAA;IACA,eAAA;EArDJ;AACF;AAuDI;EAlBF;IAmBI,gBAAA;EApDJ;AACF;;AAyDE;EACE,yDAAA;EACA,mDAAA;EACA,eAAA;AAtDJ;;AA0DA;EACE,gBAAA;EACA,eAAA;EACA,aAAA;EACA,cAAA;AAvDF;AAyDE;EACE,8BAAA;AAvDJ;;AA4DE;EACE,oCAAA;AAzDJ;;AA6DA;EA7HE,gBAAA;EACA,uBAAA;EACA,qBAAA;EACA,qBAAA;EACA,oBAAA;EACA,4BAAA;EA0HA,qBAAA;EACA,aAAA;AArDF;;AAwDA;EAnIE,gBAAA;EACA,uBAAA;EACA,qBAAA;EACA,qBAAA;EACA,oBAAA;EACA,4BAAA;EAgIA,qBAAA;EACA,aAAA;AAhDF;;AAmDA;EACE,gDAAA;EA1IA,gBAAA;EACA,uBAAA;EACA,qBAAA;EACA,qBAAA;EACA,oBAAA;EACA,4BAAA;EAuIA,qBAAA;EACA,aAAA;AA3CF;;AA8CA;EACE,4BAAA;AA3CF;;AA8CA;EACE,mBAAA;AA3CF;AA4CE;EAFF;IAGI,iBAAA;EAzCF;AACF;;AA4CA;EACE,aAAA;EACA,gDAAA;AAzCF;AA0CE;EAHF;IAII,cAAA;IA/JF,gBAAA;IACA,uBAAA;IACA,qBAAA;IACA,qBAAA;IACA,oBAAA;IACA,4BAAA;IA4JE,qBAAA;IACA,aAAA;EAlCF;AACF;;AAsCE;EADF;IAEI,aAAA;EAlCF;AACF;;AAqCA;EACE,aAAA;AAlCF;AAmCE;EAFF;IAGI,cAAA;EAhCF;AACF;;AAmCA;EACE,aAAA;EACA,mBAAA;AAhCF;;AAmCA;EACE,YAAA;AAhCF;;AAmCA;EACE,gBAAA;AAhCF;;AAmCA;EACE,aAAA;AAhCF;;AAoCE;EACE,iBAAA;EACA,oBAAA;AAjCJ;AAmCI;EACE,gBAAA;AAjCN;AAqCE;EACE;IACE,aAAA;EAnCJ;AACF;;AAwCE;EADF;IAEI,eAAA;EApCF;AACF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.engagementTableWrapper {\n  width: 100%;\n  max-width: 100%;\n  max-height: calc(100vh - 322px);\n  overflow: auto;\n  box-shadow: var(--basic-box-shadow);\n  margin-top: 25px;\n\n  @include scrollBar;\n\n  @media (max-width: 900px) {\n    margin-top: 15px;\n    max-height: calc(100vh - 280px);\n  }\n}\n\n.engagementTable {\n  width: 100%;\n  border-collapse: separate;\n  border-spacing: 0;\n  position: relative;\n\n  th {\n    font-size: 10px;\n    font-weight: 400;\n    line-height: 12px;\n    text-transform: uppercase;\n    color: var(--tables-title-text);\n    padding: 16px 25px;\n    text-align: left;\n    border-bottom: 1px solid var(--tables-title-stroke);\n    background: var(--tables-title-surface);\n    text-wrap: nowrap;\n    position: sticky;\n    top: 0;\n    z-index: 1;\n\n    @media (max-width: 1550px) {\n      padding: 16px 12px;\n    }\n\n    @media (max-width: 1380px) {\n      padding: 10px 6px;\n    }\n\n    @media (max-width: 900px) {\n      padding: 8px 3px;\n      font-size: 9px;\n    }\n  }\n\n  td {\n    padding: 16px 25px;\n    color: var(--tables-primary-row-text-main);\n    border-bottom: 1px solid var(--tables-primary-row-stroke);\n    background: var(--tables-primary-row-surface-default);\n    letter-spacing: 0.01em;\n    font-size: 12px;\n    line-height: 16px;\n\n    @media (max-width: 1550px) {\n      padding: 16px 12px;\n    }\n\n    @media (max-width: 1380px) {\n      padding: 10px 6px;\n      font-size: 10px;\n    }\n\n    @media (max-width: 900px) {\n      padding: 8px 3px;\n    }\n  }\n}\n\n.engagementBodyRow {\n  &:hover {\n    border-bottom: 1px solid var(--tables-primary-row-stroke);\n    background: var(--tables-primary-row-surface-hover);\n    cursor: pointer;\n  }\n}\n\n.engagementTableSortIcon {\n  margin-left: 5px;\n  cursor: pointer;\n  outline: none;\n  min-width: 6px;\n\n  path {\n    fill: var(--tables-title-icon);\n  }\n}\n\n.activeSort {\n  path {\n    fill: var(--tables-primary-row-icon);\n  }\n}\n\n.ellipsisTextTwoLines {\n  @include ellipsis-text;\n  -webkit-line-clamp: 2;\n  line-clamp: 2;\n}\n\n.ellipsisTextThreeLines {\n  @include ellipsis-text;\n  -webkit-line-clamp: 3;\n  line-clamp: 3;\n}\n\n.additionalField {\n  color: var(--tables-primary-row-text-additional);\n  @include ellipsis-text;\n  -webkit-line-clamp: 1;\n  line-clamp: 1;\n}\n\n.alignRightColumn {\n  text-align: right !important;\n}\n\n.lifetimeRange {\n  white-space: nowrap;\n  @media (max-width: 1070px) {\n    white-space: wrap;\n  }\n}\n\n.pointName {\n  display: none;\n  color: var(--tables-primary-row-text-additional);\n  @media (max-width: 1380px) {\n    display: block;\n    @include ellipsis-text;\n    -webkit-line-clamp: 2;\n    line-clamp: 2;\n  }\n}\n\n.smallWidthHide {\n  @media (max-width: 1380px) {\n    display: none;\n  }\n}\n\n.smallWidthShow {\n  display: none;\n  @media (max-width: 1380px) {\n    display: block;\n  }\n}\n\n.sortColumnWrapper {\n  display: flex;\n  align-items: center;\n}\n\n.skeletonText {\n  height: 24px;\n}\n\n.tooltipSizeMedium {\n  max-width: 450px;\n}\n\n.statusTypeItemContainer {\n  display: flex;\n}\n\n.skeletonRow {\n  td {\n    padding-top: 15px;\n    padding-bottom: 14px;\n\n    &:not(:last-child) {\n      padding-right: 0;\n    }\n  }\n\n  @media (max-width: 1380px) {\n    td:nth-child(n + 8) {\n      display: none;\n    }\n  }\n}\n\n.equipmentInfo {\n  @media (max-width: 900px) {\n    max-width: 85px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"engagementTableWrapper": `engagementTableWrapper__T2I0r`,
	"engagementTable": `engagementTable__awaQV`,
	"engagementBodyRow": `engagementBodyRow__Hu2OD`,
	"engagementTableSortIcon": `engagementTableSortIcon__hUZVi`,
	"activeSort": `activeSort__E2dCn`,
	"ellipsisTextTwoLines": `ellipsisTextTwoLines__j6LI1`,
	"ellipsisTextThreeLines": `ellipsisTextThreeLines__vq9S9`,
	"additionalField": `additionalField__oW0Vo`,
	"alignRightColumn": `alignRightColumn__fYFYM`,
	"lifetimeRange": `lifetimeRange__l6bPc`,
	"pointName": `pointName__wOIGW`,
	"smallWidthHide": `smallWidthHide__de2hC`,
	"smallWidthShow": `smallWidthShow__d2vuI`,
	"sortColumnWrapper": `sortColumnWrapper__uVBj4`,
	"skeletonText": `skeletonText__gBBeC`,
	"tooltipSizeMedium": `tooltipSizeMedium__dq61M`,
	"statusTypeItemContainer": `statusTypeItemContainer__nXH7M`,
	"skeletonRow": `skeletonRow__zG7Iu`,
	"equipmentInfo": `equipmentInfo__OCr8z`
};
module.exports = ___CSS_LOADER_EXPORT___;
